import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationPrices($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          rent: attribute(key: "price/rent") {
            rentPrice {
              value
            }
          }
          administration: attribute(key: "price/administration") {
            administrationPrice {
              value
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
